// eslint-disable-next-line import/prefer-default-export
export const getDishTemplate = () => {
  return {
    type: 'GET_DISH_TEMPLATE',
  };
};



// WEBPACK FOOTER //
// ./src/actions/dishTemplate.js